import React from "react";
import { Backdrop, Box, Typography } from "@mui/material";

interface PaymentLoaderProps {
  open: boolean;
  message?: string;
}

const PaymentLoader: React.FC<PaymentLoaderProps> = ({
  open,
  message = "Securely Redirecting to BharatKosh ...",
}) => {
  return (
    <Backdrop
      open={open}
      sx={{
        zIndex: (theme) => theme.zIndex.modal + 10,
        backgroundColor: "rgba(0,0,0,0.4)",
      }}
    >
      <Box
        sx={{
          width: 420,
          backgroundColor: "#fff",
          borderRadius: "12px",
          padding: "32px 24px",
          textAlign: "center",
          boxShadow: "0px 8px 30px rgba(0,0,0,0.2)",
        }}
      >
        {/* 🔁 BharatKosh Flip Loader */}
        <Box
          sx={{
            width: 100,
            height: 100,
            margin: "0 auto 16px",
            perspective: "1000px",
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: "100%",
              height: "100%",
              transformStyle: "preserve-3d",
              animation: "coinFlip 3s infinite ease-in-out",
            }}
          >
            {/* FRONT – Document */}
            <Box
              sx={{
                position: "absolute",
                inset: 0,
                backfaceVisibility: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#fff",
                borderRadius: "50%",
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              }}
            >
              <svg
                viewBox="0 0 24 24"
                width="60"
                height="60"
                fill="none"
                stroke="#06408b"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="16" y1="13" x2="8" y2="13" />
                <line x1="16" y1="17" x2="8" y2="17" />
                <polyline points="10 9 9 9 8 9" />
              </svg>
            </Box>

            {/* BACK – Rupee */}
            <Box
              sx={{
                position: "absolute",
                inset: 0,
                transform: "rotateY(180deg)",
                backfaceVisibility: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#fff",
                borderRadius: "50%",
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              }}
            >
              <svg
                viewBox="0 0 24 24"
                width="60"
                height="60"
                fill="none"
                stroke="#128807"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M6 3h12" />
                <path d="M6 8h12" />
                <path d="m6 13 8.5 10" />
                <path d="M6 13h3" />
                <path d="M9 13c6.627 0 12-5.373 12-12" />
              </svg>
            </Box>
          </Box>
        </Box>

        {/* Text */}
        <Typography sx={{ fontSize: 18, fontWeight: 600, mb: 1 }}>
          {message}
        </Typography>

        <Typography sx={{ fontSize: 14, color: "#9e9e9e" }}>
          Please do not refresh or close this window.
        </Typography>

        {/* Keyframes */}
        <style>
          {`
            @keyframes coinFlip {
              0%, 30% {
                transform: rotateY(0deg);
              }
              50%, 80% {
                transform: rotateY(180deg);
              }
              100% {
                transform: rotateY(360deg);
              }
            }
          `}
        </style>
      </Box>
    </Backdrop>
  );
};

export default PaymentLoader;
